import { IYieldCompounding } from '~/@api/generated-api-types-project/Api'
import { YieldCompoundingValue } from '~/@pages_investing/projects/_projects_ui/project-yield-text/ProjectYieldText'
import { cn } from '~/shadcn/lib/utils'
import { formatDate } from '~/@lib/utils/date.utils'
import { Text } from '~/@mid_ui/typography/Text'
import { ProjectPreviewImageAndPopup } from '~/@pages_investing/projects/_projects_ui/project-preview-and-label/ProjectPreviewImageAndPopup'
import { getProjectCollateralSubcategoryLabel } from '~/@pages_investing/projects/_projects_ui/project-collateral/labelByCollateralSubcategory'
import type { ProjectSchema } from '~/@pages_investing/projects/_project_types/project.types'
import { BackButton } from '../project-detail_ui/back-button/BackButton'
import { getPayoutDate } from './utils'
import { useRevenueFee } from '~/@pages_investing/_utils/revenue-fee/useRevenueFee'
import { HeadingOne } from '~/@mid_ui/typography/HeadingOne'

type Props = { project: ProjectSchema }

export function ProjectV1Overview({ project }: Props) {
  const lastPaymentDate = getPayoutDate(project)
  const { calculateFeeNettoAmount } = useRevenueFee()

  return (
    <div className="w-full">
      <div
        className={cn(
          'flex flex-col md:flex-row w-full border-b border-border',
          'h-auto md:h-75'
        )}>
        <div
          className={cn(
            'flex flex-col items-start flex-1 gap-10',
            'p-5 pb-[70px] md:pt-5 md:pb-15 md:px-10'
          )}>
          <BackButton>Späť</BackButton>
          <div className="flex flex-col gap-2">
            <Text className="font-semibold">
              Investičná príležitosť ID: {project.businessId}
            </Text>
            <HeadingOne className="text-3xl">Detail investície</HeadingOne>
            <div className="flex items-center gap-2.5">
              <ProjectPreviewImageAndPopup
                project={project}
                withPopup={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className={cn(
          'flex flex-col md:flex-row border-b border-border',
          '[&>div]:h-auto [&>div]:md:h-[120px]',
          '[&>div]:p-5 [&>div]:md:p-3 [&>div]:md:px-6 [&>div]:md:pb-4',
          '[&>div]:flex',
          '[&>div]:flex-row [&>div]:md:flex-col',
          '[&>div]:justify-between'
        )}>
        {lastPaymentDate && (
          <div
            className={cn(
              'p-3 px-6 pb-4 md:px-10',
              'border-r border-border',
              'border-b md:border-b-0'
            )}>
            <Text className="uppercase text-sm font-semibold text-muted">
              čas splatenia investície:
            </Text>
            <Text className="text-2xl font-semibold">
              {formatDate(lastPaymentDate)}
            </Text>
          </div>
        )}
        <div className={cn('border-r border-border', 'border-b md:border-b-0')}>
          <Text className="uppercase text-sm font-semibold text-muted">
            úroková sadzba:
          </Text>
          <Text className="text-[32px] font-semibold">
            <YieldCompoundingValue
              value={calculateFeeNettoAmount(project.scheme.fixedYield)
                .toFixed(2)
                .replace('.', ',')}
              isYieldCompounding={
                project.yieldCompounding === IYieldCompounding.Annually
              }
              yieldIconSize={22}
            />
            <span>p.a.</span>
          </Text>
        </div>
        <div>
          <Text className="uppercase text-sm font-semibold text-muted">
            typ zaistenia:
          </Text>
          <Text className="text-2xl font-semibold">
            {getProjectCollateralSubcategoryLabel(
              project.collateralInfo.collateralSubcategory
            )}
          </Text>
        </div>
      </div>
    </div>
  )
}
